var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPowerhouseIsotype = function SvgPowerhouseIsotype(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M30.018 0 10.249 16.37a6.4 6.4 0 0 0-.455 9.442l6.839 6.875a6.4 6.4 0 0 1 1.065 7.607L13.444 48H6.4A6.4 6.4 0 0 1 0 41.6V6.4A6.4 6.4 0 0 1 6.4 0zm3.713 0-3.693 6.727a6.4 6.4 0 0 0 1.054 7.574l7.255 7.355a6.4 6.4 0 0 1-.51 9.454L17.126 48H41.6a6.4 6.4 0 0 0 6.4-6.4V6.4A6.4 6.4 0 0 0 41.6 0z",
    clipRule: "evenodd"
  })));
};
export default SvgPowerhouseIsotype;